import MyCart from "./MyCart";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import SuccessBee from "../../../../assets/images/SuccessBee.svg";
import { CONSTANTS } from "client/utils/constants";
import { useNavigate } from "react-router-dom";
import navOperations from "redux/Navigation/operations";
import RequisitionAction from '../../../../../Store/Component/Requisition/RequisitionAction'
import { resetOrderRequest } from "client/utils/RequisitionUtil";
import { ReactToAPI } from "Service/OrderManagement/ObjectStructure";
import { IProductionVehicle } from "Model/IProductionVehicle";
import { IReason } from "Model/IReason";
import { IRequest } from "Model/IRequest";
import { INonStandardEquipment } from "Model/INonStandardEquipment";
import { IManagementVehicle } from "Model/IManagementVehicle";
import _ from "lodash";
import { IManagedEquipment } from "Model/IManagedEquipment";
import UploadAttachmentsDispatch from "Store/AssetManagement/UploadAttachments/UploadAttachmentsDispatch";
import RequisitionValidation from "../RequisitionValidation";
import TransferAction from "Store/Component/Transfer/TransferAction";
import WarningBee from "../../../../assets/images/PenndingApproval/Confirmation Bee.png";
import { popupInitialData } from "utils";


const MyCartContainer = (props?: any) => {

  const {
    setIsReasonDeleted,
    setIsRequestDeleted
  } = props

  ///dispatch
  const dispatch = useDispatch();
  const dispatchNav = navOperations.dispatchNav(dispatch);
  const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);
  const dispatchRemoveAttachment =
    UploadAttachmentsDispatch.dispatchRemoveAttachment(dispatch);

  ///selectors 
  const {
    requestCartList,
    productionVehicleCartList,
    nonStandardEquipmentCartList,
    managementVehicleCartList,
    reasonCartList,
    requestList,
    productionVehicleList,
    reasonList,
    nonStandardEquipmentList,
    managementVehicleList,
    selectedBranch,
    orderRequest,
    isOrderCreationSuccess,
    leadrNumber,
    isSubmitClick,
    isSaveClick,
    attachmentList,
    orderId,
    managedEquipmentList,
    managedEquipmentCartList,
    orderByIdValue,
    isEditOrder,
    isMandAFlag,
    orderEditNavigateChange,
    selectedCatalogItem,
    getUserDetails,
    isApprovalOverrideFlag,
    isCostCenterAvailableForSubmit,
    isDealerSameForAllFlag,
    validateAssetsOnSaveResult
  }: any = useSelector((state?: any) => ({
    requestCartList: state.RequisitionReducer.requestCartList,
    productionVehicleCartList: state.RequisitionReducer.productionVehicleCartList,
    nonStandardEquipmentCartList: state.RequisitionReducer.nonStandardEquipmentCartList,
    managementVehicleCartList: state.RequisitionReducer.managementVehicleCartList,
    reasonCartList: state.RequisitionReducer.reasonCartList,
    requestList: state.RequisitionReducer.requestList,
    productionVehicleList: state.RequisitionReducer.productionVehicleList,
    nonStandardEquipmentList: state.RequisitionReducer.nonStandardEquipmentList,
    managementVehicleList: state.RequisitionReducer.managementVehicleList,
    reasonList: state.RequisitionReducer.reasonList,
    selectedBranch: state.RequisitionReducer.selectedBranch,
    orderRequest: state.RequisitionReducer.orderRequest,
    isOrderCreationSuccess: state.RequisitionReducer.isOrderCreationSuccess,
    leadrNumber: state.RequisitionReducer.leadrNumber,
    isSubmitClick: state.RequisitionReducer.isSubmitClick,
    isSaveClick: state.RequisitionReducer.isSaveClick,
    attachmentList: state.UploadAttachmentsReducer.list,
    orderId: state.RequisitionReducer.orderId,
    managedEquipmentList: state.RequisitionReducer.managedEquipmentList,
    managedEquipmentCartList: state.RequisitionReducer.managedEquipmentCartList,
    orderByIdValue: state.OrderReducer.orderByIdData,
    isEditOrder: state.RequisitionReducer.isEditOrder,
    isMandAFlag: state.RequisitionReducer.isMandAFlag,
    orderEditNavigateChange: state.RequisitionReducer.orderEditNavigateChange,
    selectedCatalogItem: state.RequisitionReducer.selectedCatalogItem,
    getUserDetails: state.UserProfile.getUserDetails,
    isApprovalOverrideFlag: state.RequisitionReducer.isApprovalOverrideFlag,
    isCostCenterAvailableForSubmit: state.TransferReducer.isCostCenterAvailableForSubmit,
    isDealerSameForAllFlag : state.RequisitionReducer.isDealerSameForAllFlag,
    validateAssetsOnSaveResult: state.TransferReducer.validateAssetsOnSaveResult,
  }), shallowEqual);
  const activeNavigation = useSelector((state: any) => state.nav.nav);
  const navigate = useNavigate();

  const [productionCartVehicleListTemp, setProductionVehicleCartListTemp] = useState<IProductionVehicle[]>([]);
  const [nonStandardEquipmentCartListTemp, setNonStandardEquipmentCartListTemp] = useState<INonStandardEquipment[]>([]);
  const [managedEquipmentCartListTemp, setManagedEquipmentCartListTemp] = useState<IManagedEquipment[]>([]);
  const [managementVehicleCartListTemp, setManagementVehicleCartListTemp] = useState<IManagementVehicle[]>([]);
  const [reasonCartListTemp, setReasonCartListTemp] = useState<IReason[]>([]);
  const pendingSubmitContext = useRef<any>(null);
  const [requestExpand, setRequestExpand] = useState(false)
  const duplicateVinWarningMessage = "The VIN/Serial# that you have entered already exists on an item in this order.";

  useEffect(() => {

    let productionCartVehicleListTemp = productionVehicleCartList?.length > 0 ? JSON.parse(JSON.stringify(productionVehicleCartList)) : [];
    let nonStandardEquipmentCartListTemp = nonStandardEquipmentCartList?.length > 0 ? JSON.parse(JSON.stringify(nonStandardEquipmentCartList)) : [];
    let managedEquipmentCartListTemp = managedEquipmentCartList?.length > 0 ? JSON.parse(JSON.stringify(managedEquipmentCartList)) : [];
    let managementVehicleCartListTemp = managementVehicleCartList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleCartList)) : [];
    let reasonCartListTemp = reasonCartList?.length > 0 ? JSON.parse(JSON.stringify(reasonCartList)) : [];

    //update the quantity
    let reasonCount = 0
    if (productionCartVehicleListTemp?.length) {
      for (let i = 0; i < productionCartVehicleListTemp.length; i++) {
        reasonCount = 0;
        for (let j = 0; j < reasonCartListTemp.length; j++) {
          if (productionCartVehicleListTemp[i].requestIndex === reasonCartListTemp[j].requestIndex) {
            reasonCount = reasonCount + 1;
          }
        }
        productionCartVehicleListTemp[i].quantity = reasonCount
      }
    }
    if (managedEquipmentCartListTemp?.length) {
      for (let i = 0; i < managedEquipmentCartListTemp.length; i++) {
        reasonCount = 0;
        for (let j = 0; j < reasonCartListTemp.length; j++) {
          if (managedEquipmentCartListTemp[i].requestIndex === reasonCartListTemp[j].requestIndex) {
            reasonCount = reasonCount + 1;
          }
        }
        managedEquipmentCartListTemp[i].quantity = reasonCount
      }
    }

    // Non-Standard Equipment is now item-based (no quantity-derived replication).

    if (managementVehicleCartListTemp?.length) {
      reasonCount = 0
      for (let i = 0; i < managementVehicleCartListTemp.length; i++) {
        reasonCount = 0;
        for (let j = 0; j < reasonCartListTemp.length; j++) {
          if (managementVehicleCartListTemp[i].requestIndex === reasonCartListTemp[j].requestIndex) {
            reasonCount = reasonCount + 1;
          }
        }
        managementVehicleCartListTemp[i].quantity = reasonCount
      }
    }

    const calculatePrice = (requestData: any) => {
      let quntity = 0;
      reasonCartListTemp?.forEach((reasonData: any) => {
        if (reasonData?.requestIndex === requestData?.requestIndex && reasonData?.estimatedPrice && reasonData?.showQuotePrice && reasonData?.quotePrice) {
          let estimatedPrice = reasonData.estimatedPrice?.toString().includes(',') ? parseFloat(reasonData.estimatedPrice?.replace(/,/g, "")) : reasonData.estimatedPrice
          price = price + Number(estimatedPrice);
          quntity += 1;
        }
      })
      if (requestData.price || requestData.pricePerUnit) {
        let totalquntity = requestData.quantity - quntity;
        price = price + (Number(requestData.price || requestData.pricePerUnit) * totalquntity);
      }
      return price
    }

    //Calculate Grand Total
    let price = 0;
    if (productionCartVehicleListTemp?.length) {
      productionCartVehicleListTemp?.forEach((requestData: any) => {
        price = calculatePrice(requestData)
      })
    }
    if (nonStandardEquipmentCartListTemp?.length) {
      nonStandardEquipmentCartListTemp?.forEach((requestData: any) => {
        if (requestData.price || requestData.pricePerUnit) {
          price = price + Number(String(requestData.price || requestData.pricePerUnit).split(",").join(""));
        }
      })
    }
    if (managedEquipmentCartListTemp?.length) {
      managedEquipmentCartListTemp?.forEach((requestData: any) => {
        let managedEquipmentPrice = requestData.price?.toString().includes(',') ? parseFloat(requestData?.price?.replace(/,/g, "")) : requestData.price
        if ((requestData.price || requestData.pricePerUnit) && !requestData?.showQuotePrice) {
          price = price + (Number(managedEquipmentPrice || requestData.pricePerUnit) * requestData.quantity);
        }
        else if ((requestData.price || requestData.pricePerUnit) && requestData.showQuotePrice) {
          price = price + (Number(managedEquipmentPrice));
        }
      })

    }
    if (managementVehicleCartListTemp?.length) {
      managementVehicleCartListTemp?.forEach((requestData: any) => {
        price = calculatePrice(requestData)
      })
    }
    setGrandTotal(price)

    setProductionVehicleCartListTemp(productionCartVehicleListTemp);
    setManagedEquipmentCartListTemp(managedEquipmentCartListTemp);
    setNonStandardEquipmentCartListTemp(nonStandardEquipmentCartListTemp);
    setManagementVehicleCartListTemp(managementVehicleCartListTemp);
    setReasonCartListTemp(reasonCartListTemp);

  }, [reasonCartList, requestCartList, productionVehicleCartList, nonStandardEquipmentCartList, managedEquipmentCartList, managementVehicleCartList])

  useEffect(() => {
    if ((isSubmitClick || isSaveClick) && orderRequest !== undefined && orderRequest !== "") {
      if (((productionVehicleList?.length == productionVehicleCartList?.length
        || nonStandardEquipmentList?.length == nonStandardEquipmentCartList?.length
        || managedEquipmentList?.length == managedEquipmentCartList?.length
        || managementVehicleList?.length == managementVehicleCartList?.length)
        && reasonCartList?.length == reasonList?.length && reasonCartList.length > 0)
        || isSaveClick) {
        // Send API object (Order request) to Saga
        dispatch(RequisitionAction.createOrderRequest(orderRequest));
      }
    }
  }, [orderRequest]);

  useEffect(() => {
    if ((isSubmitClick || isSaveClick) && (isOrderCreationSuccess?.hasOwnProperty("orderId"))) {
      orderResponsePopUp();
      dispatch(RequisitionAction.setIsChangesOccured(false))
      dispatch(TransferAction.setIsChangesOccuredInCart(false))
    }
  }, [isOrderCreationSuccess, leadrNumber, isSaveClick, isSubmitClick]);

  //state
  const [grandTotal, setGrandTotal] = useState(0);

  //need to genetate distince from IRequest
  const requestType = [{
    requestType: CONSTANTS.PRODUCTION_VEHICLE,
    collapse: true,
  }, {
    requestType: CONSTANTS.NON_STANDARD_EQUIPMENT,
    collapse: true,
  }, {
    requestType: CONSTANTS.MANAGED_EQUIPMENT,
    collapse: true,
  }];

  const [requestTypeList, setrequestTypeList] = useState(requestType);
  const [childRequestList, setChildRequestList] = useState<any>([]);

 
  useEffect(() => {
    let requestList1 = [];
    let childRequestList1 = [];
    setRequestExpand(reasonCartList?.length === 1)
    if (reasonCartList?.length > 0) {
      for (let i = 0; i < requestCartList.length; i++) {
        const requestTemp = {
          requestType: requestCartList[i].requestType,
          collapse: true,
        }
        const childRequestTemp = {
          requestIndex: requestCartList[i].requestIndex,
          requestType: requestCartList[i].requestType,
          expand: reasonCartList.length === 1
        }
        childRequestList1.unshift(childRequestTemp);
        if (requestList1.length <= 0) {
          requestList1.unshift(requestTemp);
        } else {
          let isRequestTypeExist
          for (let j = 0; j < requestList1.length; j++) {
            if (requestList1[j].requestType === requestCartList[i].requestType) {
              isRequestTypeExist = true;
            }
          }
          if (!isRequestTypeExist) {
            requestList1.unshift(requestTemp)
          }
        }
      }
    }
    setrequestTypeList(requestList1);
    setChildRequestList(childRequestList1)
  }, [requestCartList])

  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);

  useEffect(() => {
    if (!validateAssetsOnSaveResult || !pendingSubmitContext.current) return;

    const failed = validateAssetsOnSaveResult.filter((r: any) => !r.isValid);

    if (failed.length > 0) {
      const updateReasons = (list: any[]) => list?.map((r: any) => {
        const failedEntry = failed.find((f: any) => f.assetNumber == Number(r.asset));
        if (failedEntry) {
          const orderRef = failedEntry.conflictingOrderNumber ? ` LEADR # ${failedEntry.conflictingOrderNumber}` : "";
          return { ...r, assetError: failedEntry.validationMessage + orderRef };
        }
        return { ...r, assetError: "" };
      });
      dispatch(RequisitionAction.setIReason(updateReasons(reasonList)));

      // Show popup listing invalid asset numbers — same pattern as purchaseOrder-container.tsx
      const invalidAssetNumbers = failed.map((r: any) => r.assetNumber);
      setPopupcontent({
        ...popupInitialData,
        titleImg: ConfirmationBee,
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: (
          <p>Please enter the valid asset in items {invalidAssetNumbers.map((num: any) => <span key={num}>{num} </span>)} before saving.</p>
        ),
        outlineBtnText: "Ok",
        popupOutlinebtnOnclick: popupOutlinebtnOnclick,
        isSingleConfirmationBtn: true,
      });
    } else {
      ReactToAPI(pendingSubmitContext.current);
    }

    dispatch(TransferAction.setValidateAssetsOnSave(null));
    pendingSubmitContext.current = null;
  }, [validateAssetsOnSaveResult]);

  const [cancelPopupcontent, setCancelPopupcontent] = useState<any>(popupInitialData);

  const hasDuplicateNseVinSerialInCart = () => {
    const vinSerial = new Set<string>();
    for (const item of nonStandardEquipmentCartList || []) {
      const normalizedVinSerial = (item?.vinSerial || "").trim().toLowerCase();
      if (!normalizedVinSerial) {
        continue;
      }
        if (vinSerial.has(normalizedVinSerial)) {
        return true;
      }
        vinSerial.add(normalizedVinSerial);
    }
    return false;
  };

  const showDuplicateNseVinWarningPopup = (onConfirm: () => void) => {
    setPopupcontent({
      ...popupInitialData,
      titleImg: ConfirmationBee,
      title: "ALREADY EXISTS",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: (
        <>
          <p>{duplicateVinWarningMessage}</p>
        </>
      ),
      primaryBtnText: "",
      outlineBtnText: "Ok",
      isSingleConfirmationBtn: true,
      popupOutlinebtnOnclick: () => {
        hideDialog();
        onConfirm();
      },
      popupPrimarybtnOnclick: () => {
        hideDialog();
        onConfirm();
      }
    });
  };


  const onClickDeleteReasonFromCart = (e: any, reason: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    let requestListTemp1 = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];

    let reasonCount = 0;
    for (let i = 0; i < requestListTemp1.length; i++) {
      if (requestListTemp1[i].requestIndex === reason.requestIndex) {
        reasonCount = reasonCount + 1
      }
    }
    if (reasonCount == 1) {
      let decriptionTxt = (
        <p>Request must contain atleast one reason.</p>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "Information",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Ok",
        popupOutlinebtnOnclick: popupOutlinebtnOnclick,
        isSingleConfirmationBtn: true,
      });
    }
    else {

      //delete reason from cart
      let reasonCartListTemp1 = reasonCartList?.length > 0 ? JSON.parse(JSON.stringify(reasonCartList)) : [];
      for (let i = 0; i < reasonCartListTemp1.length; i++) {
        if (reasonCartListTemp1[i]?.reasonIndex === reason?.reasonIndex) {
          
          if(reasonCartListTemp1[i]?.requestType === CONSTANTS.MANAGED_EQUIPMENT && isDealerSameForAllFlag){
            setIsReasonDeleted(true);
            if((checkManagedEquipCount() - 1) <= 1){
              dispatch(RequisitionAction.setIsDealerSameForAllFlagFlag(false))
            }
          }
          reasonCartListTemp1.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setCartIReason(reasonCartListTemp1))

      

      //delete reason from item detail      
      for (let i = 0; i < requestListTemp1.length; i++) {
        if (requestListTemp1[i]?.reasonIndex === reason?.reasonIndex) {
          requestListTemp1.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setIReason(requestListTemp1))

      //check the driverDetailList when reason got deleted
      if (reason.requestType === CONSTANTS.MANAGEMENT_VEHICLE) {
        let managementVehicleListtemp = managementVehicleList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleList)) : [];

        for (let i = 0; i < managementVehicleListtemp.length; i++) {
          if (managementVehicleListtemp[i].requestIndex === reason.requestIndex) {
            let isDriver = RequisitionValidation.ValidateVehicleDriverDetails(managementVehicleListtemp[i], requestListTemp1);
            managementVehicleListtemp[i].vehicleDriverDetailsError = isDriver.request.vehicleDriverDetailsError;
            managementVehicleListtemp[i].isExistInCart = false;
          }
        }
        dispatch(RequisitionAction.setIManagementVehicle(managementVehicleListtemp))
      }

      if (reason?.showQuotePrice) {
        let previousprice = 0;
        for (let i = 0; i < requestListTemp1.length; i++) {
          if (requestListTemp1[i].requestIndex === reason.requestIndex) {

            let val = parseFloat(requestListTemp1[i].estimatedPrice?.replace(/,/g, "")).toFixed(2)
            previousprice = previousprice + parseFloat(val);
          }
        }
        let managedEquipmentListTemp = managedEquipmentList?.length > 0 ? JSON.parse(JSON.stringify(managedEquipmentList)) : [];
        for (let i = 0; i < managedEquipmentListTemp?.length; i++) {
          if (managedEquipmentListTemp[i].requestIndex === reason.requestIndex) {
            managedEquipmentListTemp[i].price = previousprice;
          }
        }
        dispatch(RequisitionAction.setIManagedEquipment(managedEquipmentListTemp));
        let managedEquipmentCartListTemp = managedEquipmentCartList?.length > 0 ? JSON.parse(JSON.stringify(managedEquipmentCartList)) : [];
        for (let i = 0; i < managedEquipmentCartListTemp?.length; i++) {
          if (managedEquipmentCartListTemp[i].requestIndex === reason.requestIndex) {
            managedEquipmentCartListTemp[i].price = previousprice;
          }
        }
        dispatch(RequisitionAction.setCartIManagedEquipment(managedEquipmentCartListTemp));
      }
    }
  }

  const validateDriverList = () => {
    let isDriverDetailValid = true;

    if (managementVehicleCartList?.length > 0) {
      let managementVehicleCartListtemp = managementVehicleCartList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleCartList)) : [];
      for (let i = 0; i < managementVehicleCartListtemp.length; i++) {
        let isDriver = RequisitionValidation.ValidateVehicleDriverDetails(managementVehicleCartListtemp[i], reasonCartList);
        if (!isDriver.isValid) {
          isDriverDetailValid = false;
        }
      }
    }
    return isDriverDetailValid;
  }

  const mandatoryPopup = () => {
    let decriptionTxt = (
      <div>
        <p>Mandatory value are required.</p>
        <p> Please update the cart details.</p>
      </div>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "INFORMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "Ok",
      popupOutlinebtnOnclick: () => { hideDialog(); },
      isSingleConfirmationBtn: true,
    });
  }
  const onClickDeleteRequestFromCart = (e: any, request: any) => {
    dispatch(RequisitionAction.setIsEditRequestClick(false))
    dispatch(RequisitionAction.setEditRequestDetails({}))
    dispatch(RequisitionAction.setIsChangesOccured(true))
    //delete request
    let requestList1 = requestList?.length > 0 ? JSON.parse(JSON.stringify(requestList)) : [];
    for (let i = 0; i < requestList1.length; i++) {
      if (requestList1[i]?.requestIndex === request?.requestIndex) {
        requestList1.splice(i, 1);
      }
    }
    dispatch(RequisitionAction.setIRequest(requestList1))

    //Delete vehicle
    if (request?.requestType === CONSTANTS.PRODUCTION_VEHICLE) {
      let productionVehicleList1 = productionVehicleList?.length > 0 ? JSON.parse(JSON.stringify(productionVehicleList)) : [];
      for (let i = 0; i < productionVehicleList1.length; i++) {
        if (productionVehicleList1[i]?.requestIndex === request?.requestIndex) {
          productionVehicleList1.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setIProductionVehicle(productionVehicleList1))
    } else if (request?.requestType === CONSTANTS.NON_STANDARD_EQUIPMENT) {
      //Delete equipment
      let nonStandardEquipmentList1 = nonStandardEquipmentList?.length > 0 ? JSON.parse(JSON.stringify(nonStandardEquipmentList)) : [];
      for (let i = 0; i < nonStandardEquipmentList1.length; i++) {
        if (nonStandardEquipmentList1[i]?.requestIndex === request?.requestIndex) {
          nonStandardEquipmentList1.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setINonStandardEquipment(nonStandardEquipmentList1))
    } else if (request?.requestType == CONSTANTS.MANAGED_EQUIPMENT) {
      let managedEquipmentListtemp = managedEquipmentList?.length > 0 ? JSON.parse(JSON.stringify(managedEquipmentList)) : [];
      for (let i = 0; i < managedEquipmentListtemp.length; i++) {
        if (managedEquipmentListtemp[i]?.requestIndex === request?.requestIndex) {
         
          if(isDealerSameForAllFlag ){
            let requestReasonLength = reasonList?.filter((item?: any) => item?.requestIndex === request?.requestIndex)?.length
            if((checkManagedEquipCount() - requestReasonLength) <= 1){
              dispatch(RequisitionAction.setIsDealerSameForAllFlagFlag(false))
            }
          setIsRequestDeleted(true)
          }
          managedEquipmentListtemp.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setIManagedEquipment(managedEquipmentListtemp))
    } else if (request?.requestType == CONSTANTS.MANAGEMENT_VEHICLE) {
      let managementVehicleListtemp = managementVehicleList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleList)) : [];
      for (let i = 0; i < managementVehicleListtemp.length; i++) {
        if (managementVehicleListtemp[i]?.requestIndex === request?.requestIndex) {
          managementVehicleListtemp.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setIManagementVehicle(managementVehicleListtemp))
    }

    //delete reason
    let reasonList1 = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];

    let IndexVal = reasonList1.length - 1;
    while (IndexVal >= 0) {
      if (reasonList1[IndexVal]?.requestIndex === request?.requestIndex) {
        reasonList1.splice(IndexVal, 1);
      }
      IndexVal -= 1;
    }
    dispatch(RequisitionAction.setIReason(reasonList1))

    //delete request  from cart    
    let requestCartListTemp = requestCartList?.length > 0 ? JSON.parse(JSON.stringify(requestCartList)) : [];
    for (let i = 0; i < requestCartListTemp.length; i++) {
      if (requestCartListTemp[i]?.requestIndex === request?.requestIndex) {
        requestCartListTemp.splice(i, 1);
      }
    }
    dispatch(RequisitionAction.setCartIRequest(requestCartListTemp))

    if (request?.requestType === CONSTANTS.PRODUCTION_VEHICLE) {
      //Delete vehicle  from cart    
      let productionVehicleCartListTemp = productionVehicleCartList?.length > 0 ? JSON.parse(JSON.stringify(productionVehicleCartList)) : [];
      for (let i = 0; i < productionVehicleCartListTemp.length; i++) {
        if (productionVehicleCartListTemp[i]?.requestIndex === request?.requestIndex) {
          productionVehicleCartListTemp.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setCartIProductionVehicle(productionVehicleCartListTemp))

    } else if (request?.requestType === CONSTANTS.NON_STANDARD_EQUIPMENT) {
      //Delete equipment  from cart    
      let nonStandardEquipmentCartListTemp = nonStandardEquipmentCartList?.length > 0 ? JSON.parse(JSON.stringify(nonStandardEquipmentCartList)) : [];
      for (let i = 0; i < nonStandardEquipmentCartListTemp.length; i++) {
        if (nonStandardEquipmentCartListTemp[i]?.requestIndex === request?.requestIndex) {
          nonStandardEquipmentCartListTemp.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setCartINonStandardEquipment(nonStandardEquipmentCartListTemp))

    } else if (request?.requestType == CONSTANTS.MANAGED_EQUIPMENT) {
      let managedEquipmentCartListTemp = managedEquipmentCartList?.length > 0 ? JSON.parse(JSON.stringify(managedEquipmentCartList)) : [];
      for (let i = 0; i < managedEquipmentCartListTemp.length; i++) {
        if (managedEquipmentCartListTemp[i]?.requestIndex === request?.requestIndex) {
          managedEquipmentCartListTemp.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setCartIManagedEquipment(managedEquipmentCartListTemp))
    } else if (request?.requestType == CONSTANTS.MANAGEMENT_VEHICLE) {
      let managementVehicleCartListTemp = managementVehicleCartList?.length > 0 ? JSON.parse(JSON.stringify(managementVehicleCartList)) : [];
      for (let i = 0; i < managementVehicleCartListTemp.length; i++) {
        if (managementVehicleCartListTemp[i]?.requestIndex === request?.requestIndex) {
          managementVehicleCartListTemp.splice(i, 1);
        }
      }
      dispatch(RequisitionAction.setCartIManagementVehicle(managementVehicleCartListTemp))
    }

    //delete reason   from cart   
    let reasonCartListTemp = reasonCartList?.length > 0 ? JSON.parse(JSON.stringify(reasonCartList)) : [];
    let index = reasonCartListTemp.length - 1;
    while (index >= 0) {
      if (reasonCartListTemp[index]?.requestIndex === request?.requestIndex) {
        reasonCartListTemp.splice(index, 1);
      }
      index -= 1;
    }
    dispatch(RequisitionAction.setCartIReason(reasonCartListTemp))

    //delete attachment
    if (!requestCartListTemp.length) {
      if (attachmentList?.length > 0) {
        const newArr = JSON.parse(JSON.stringify(attachmentList));
        for (let i = 0; i < attachmentList.length; i++) {
          newArr.pop();
        }
        dispatchRemoveAttachment(newArr);
      }
    }

    //unselect catalog item after deleting the request

    let remainingCatalogItem = selectedCatalogItem?.length > 0 ? JSON.parse(JSON.stringify(selectedCatalogItem)) : [];

    remainingCatalogItem.forEach((item: any) => {
      if (request?.assetModelId === item?.assetModelId) {
        item.isSelected = false
      }
    })

    dispatch(RequisitionAction.setSelectedCatalogItem(remainingCatalogItem))
  }

  const handleCollapseClick = (index: any) => {
    let requestTypeList1 = JSON.parse(JSON.stringify(requestTypeList))
    requestTypeList1[index].collapse = !requestTypeList1[index].collapse
    setrequestTypeList(requestTypeList1)
  }

  const submitOrder = (skipDuplicateVinWarning: boolean = false) => {
    if (!skipDuplicateVinWarning && hasDuplicateNseVinSerialInCart()) {
      showDuplicateNseVinWarningPopup(() => submitOrder(true));
      return;
    }

    dispatch(RequisitionAction.isSubmitClick(true));
    dispatch(RequisitionAction.isSaveClick(false));
    dispatch(RequisitionAction.setIsOrderCreationSuccess({}));
    const orderAction = CONSTANTS.ORDER_SUBMIT;
    const submitContext = {
      productionVehicleCartList,
      nonStandardEquipmentCartList,
      managedEquipmentCartList,
      managementVehicleCartList,
      reasonCartList,
      selectedBranch,
      getUserDetails,
      orderAction,
      dispatch,
      attachmentList,
      orderId,
      isMandAFlag,
      isApprovalOverrideFlag,
      isDealerSameForAllFlag
    };
    const assetsToValidate = reasonCartList
      ?.filter((r: any) => r.asset && Number(r.asset) > 0)
      ?.map((r: any) => ({ assetNumber: Number(r.asset), reasonReplacementId: r.reasonId || 0 }));

    if (!assetsToValidate || assetsToValidate.length === 0) {
      ReactToAPI(submitContext);
      return;
    }
    pendingSubmitContext.current = submitContext;
    dispatch(TransferAction.getValidateAssetsOnSave({
      requestType: CONSTANTS.REQUISITION,
      assets: assetsToValidate
    }));
  }

  const handleClickComplete = () => {

    if (productionVehicleList?.length == productionVehicleCartList?.length
      && reasonCartList?.length == reasonList?.length
      && managedEquipmentCartList?.length == managedEquipmentList?.length || 0) {
      if (reasonCartList?.length > 0) {
        const isValid = validateDriverList()
        if (isValid) {
          submitOrder();
        } else {
          mandatoryPopup();
        }
      }
      else {
        let decriptionTxt = (
          <p>Atleast one reason is required to create an order</p>
        );
        setPopupcontent({
          ...Popupcontent,
          titleImg: ConfirmationBee,
          title: "INFORMATION",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: decriptionTxt,
          outlineBtnText: "Ok",
          popupOutlinebtnOnclick: popupOutlinebtnOnclick,
          isSingleConfirmationBtn: true,
        });
      }

    } else {
      let decriptionTxt = (
        <p>Please provide details for all added request and reason</p>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "CONFIRMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Ok",
        popupOutlinebtnOnclick: popupOutlinebtnOnclick,
        isSingleConfirmationBtn: true,
      });
    }
    dispatch(RequisitionAction.setIsEditRequestClick(false))
    dispatch(RequisitionAction.setEditRequestDetails({}))
  };

  const saveOrder = (skipDuplicateVinWarning: boolean = false) => {
    if (!skipDuplicateVinWarning && hasDuplicateNseVinSerialInCart()) {
      showDuplicateNseVinWarningPopup(() => saveOrder(true));
      return;
    }

    dispatch(RequisitionAction.isSaveClick(true));
    dispatch(RequisitionAction.isSubmitClick(false));
    dispatch(RequisitionAction.setIsOrderCreationSuccess({}));
    const orderAction = CONSTANTS.ORDER_SAVE;
    ReactToAPI({
      productionVehicleCartList,
      nonStandardEquipmentCartList,
      managedEquipmentCartList,
      managementVehicleCartList,
      reasonCartList,
      selectedBranch,
      getUserDetails,
      orderAction,
      dispatch,
      attachmentList,
      orderId,
      isMandAFlag,
      isApprovalOverrideFlag,
      isDealerSameForAllFlag
    });
  }

  const handleClickSave = () => {
    if (reasonCartList?.length > 0) {
      const isValid = validateDriverList()
      if (isValid) {
        saveOrder();
      } else {
        mandatoryPopup();
      }
    }
    else {
      let decriptionTxt = (
        <p>Atleast one reason is required to save an order</p>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Ok",
        popupOutlinebtnOnclick: popupOutlinebtnOnclick,
        isSingleConfirmationBtn: true,
      });
    }

  }

  const orderResponsePopUp = () => {

    let popUpDecriptionTxt = (
      <>
        <p>Error occured while creating the Order Request.</p>
      </>
    );
    let popUpTitle = CONSTANTS.TITLE_CONFIRMATION;
    let popUpTitleImg = ConfirmationBee;

    if (isOrderCreationSuccess?.orderId != null && isOrderCreationSuccess?.hasOwnProperty("orderId")) {
      if (isSaveClick) {
        popUpDecriptionTxt = (
          <>
            <p>Requisition has been saved successfully.</p>
          </>
        );
      } else if (isSubmitClick) {
        popUpDecriptionTxt = (
          <>
            <p>Requisition has been created successfully.</p>
            <p>
              <b>{CONSTANTS.LEADR_ORDER_NUMBER} :</b> {leadrNumber}
            </p>
          </>
        );
      }

      popUpTitle = CONSTANTS.TITLE_SUCCESS;
      popUpTitleImg = SuccessBee;
    }else if(isOrderCreationSuccess?.errorMessage != ""){
      popUpDecriptionTxt = (
        <>
          <p>{isOrderCreationSuccess?.errorMessage}</p>
        </>
      );
      popUpTitle = "WARNING";
      popUpTitleImg = WarningBee;
    }

    setPopupcontent({
      ...Popupcontent,
      titleImg: popUpTitleImg,
      title: popUpTitle,
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: popUpDecriptionTxt,
      primaryBtnText: "",
      outlineBtnText: "Close",
      popupOutlinebtnOnclick: popupOutlinebtnOnclick,
      isSingleConfirmationBtn: true,
    });

  }

  const hideDialog = () => {
    setPopupcontent({ isDialogVisible: false })
  };

  const hideDialogCancel = () => {
    setCancelPopupcontent({ ...cancelPopupcontent, isDialogVisible: false })
  };

  const popupOutlinebtnOnclick = () => {
    hideDialog();
    if (isOrderCreationSuccess?.hasOwnProperty("orderId") && isOrderCreationSuccess?.orderId != null  && (isSubmitClick || isSaveClick)) {
      let navigatepage = "";
      if (activeNavigation === "MyOrderDetail") {
        navigatepage = orderEditNavigateChange ?? CONSTANTS.ACTIVE_HEADER.HOME;
      } else {
        navigatepage = activeNavigation;
      }
      resetOrderRequest(dispatch);
      dispatchNav(navigatepage);
      dispatchHeaderNav(navigatepage);
      navigate('/ordermanagement');
    }
  };

  const popupOutlinebtnOnclickCancel = () => {
    hideDialogCancel();
    if (isOrderCreationSuccess?.hasOwnProperty("orderId") && isOrderCreationSuccess?.orderId != null && (isSubmitClick || isSaveClick)) {
      resetOrderRequest(dispatch);
      dispatchNav("Home");
      dispatchHeaderNav("Home");
      navigate('/ordermanagement')
    }
  };

  const popupPrimarybtnOnclickCancel = () => {
    hideDialogCancel();
    dispatch(RequisitionAction.isSubmitClick(false));
    dispatch(RequisitionAction.setIsOrderCreationSuccess({}));
    dispatch(RequisitionAction.setIsChangesOccured(false));
    dispatch(TransferAction.setIsChangesOccuredInCart(false))
    if (!isSaveClick || isSaveClick == undefined) {
      resetOrderRequest(dispatch);
      dispatchNav("Home");
      dispatchHeaderNav("Home");
      navigate('/ordermanagement')
    }
  };
  const handleClickCancel = () => {
    dispatch(RequisitionAction.isSaveClick(false));
    dispatch(RequisitionAction.isSubmitClick(false));
    dispatch(RequisitionAction.setIsOrderCreationSuccess({}));
    let decriptionTxt = (
      <p>Are you sure you want to cancel the New Order</p>
    );
    setCancelPopupcontent({
      ...cancelPopupcontent,
      titleImg: ConfirmationBee,
      title: "CONFIRMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      popupPrimarybtnOnclick: popupPrimarybtnOnclickCancel,
      popupOutlinebtnOnclick: popupOutlinebtnOnclickCancel,
      isSingleConfirmationBtn: false,
    });
  };

  const handleClickCheckbox = () => {
    setRequestExpand(!requestExpand)
    const requestTypeChange = requestTypeList
    requestTypeChange.forEach((_item :any) => {
      _item.collapse = true
    })
    setrequestTypeList([...requestTypeChange])

    const requestTypeTemp = childRequestList
    requestTypeTemp.forEach((_item :any) => {
        _item.expand = !requestExpand
    })
    setChildRequestList([...requestTypeTemp])
  }

  const handleClickRequestToggle = (item: any) => {
    const requestTypeChange = childRequestList
    requestTypeChange.forEach((_item :any) => {
      if(_item?.requestType === item?.requestType && _item?.requestIndex === item?.requestIndex){
        _item.expand = !_item.expand
      }
    })
    setChildRequestList([...requestTypeChange])
  }

  const getExpand = (request:any) => {
    let isExpand;
    childRequestList.map((_item:any)=>{
      if(request?.requestIndex === _item?.requestIndex){
        isExpand = _item.expand;
      }
    })
    return isExpand;
  }

  const checkManagedEquipCount = () => {
    let count = 0;
    reasonList?.map((item?: any) => {
      if(item?.requestType === CONSTANTS.MANAGED_EQUIPMENT){
      count = count + 1;
      }
    });
    return count;
  }

  return (
    <MyCart
      requestTypeList={requestTypeList}
      childRequestList={childRequestList}
      productionCartVehicleList={productionCartVehicleListTemp}
      nonStandardEquipmentCartList={nonStandardEquipmentCartListTemp}
      managementVehicleCartList={managementVehicleCartListTemp}
      reasonCartList={reasonCartListTemp?.sort((a, b) => b?.reasonIndex - a?.reasonIndex)}
      grandTotal={grandTotal}
      handleCollapseClick={handleCollapseClick}
      Popupcontent={Popupcontent}
      cancelPopupcontent={cancelPopupcontent}
      handleClickComplete={handleClickComplete}
      handleClickSave={handleClickSave}
      hideDialog={hideDialog}
      hideDialogCancel={hideDialogCancel}
      handleClickCancel={handleClickCancel}
      onClickDeleteRequestFromCart={onClickDeleteRequestFromCart}
      onClickDeleteReasonFromCart={onClickDeleteReasonFromCart}
      managedEquipmentList={managedEquipmentList}
      managedEquipmentCartList={managedEquipmentCartListTemp}
      isEditOrder={isEditOrder}
      orderByIdValue={orderByIdValue}
      handleClickCheckbox={handleClickCheckbox}
      handleClickRequestToggle={handleClickRequestToggle}
      requestExpand={requestExpand}
      getExpand={getExpand}
      isCostCenterAvailableForSubmit = {isCostCenterAvailableForSubmit}
    />
  )
}

export default MyCartContainer;
